/**
 * Simple Video Player
 * Use when you just want to display a video.
 * If you need to track progress, or other activities please see fullPlayer.tsx
 */
import React from 'react'

type Props = {
  id: string, // id of the iframe
  srcUrl: string, // url of the video to be played
  onLoad?: () => void, // function to be called when the iframe is loaded
}
const VideoPlayer: React.FC<Props> = ({ id, srcUrl, onLoad = () => {} }) => {
  return (
    <div className='relative pt-[50%]'>
      <iframe
        id={id}
        src={srcUrl}
        loading='lazy'
        className='border-0 absolute top-0 h-full w-full'
        allow='accelerometer; gyroscope; encrypted-media; picture-in-picture;'
        allowFullScreen
        onLoad={onLoad}
      />
    </div>
  )
}

export default VideoPlayer
